import request from '@/utils/request'

let Voucher_typeApi = {

  /*券类型列表*/
  list(data) {
    return request._post('/shop/plus.voucher_type.Index/index', data);
},
/*添加券类型*/
add(data) {
    return request._post('/shop/plus.voucher_type.Index/add', data);
},
/*修改券类型*/
edit(data) {
    return request._post('/shop/plus.voucher_type.Index/edit', data);
},
/*删除券类型*/
del(data) {
    return request._post('/shop/plus.voucher_type.Index/del', data);
},
/*券类型详情*/
detail(data) {
  return request._post('/shop/plus.voucher_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.voucher_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.voucher_type.Setting/getSetting', data, errorback);
    },
}
export default Voucher_typeApi;



// WEBPACK FOOTER //
// ./src/api/voucher_type.js